import { useState } from "react";

const initialPosts = [
  {
    id: 1,
    title: "AI is the competitor",
    topic: "AI & Product",
    status: "in-progress",
    scheduledDate: "",
    hook: "AI didn't just create new products. It changed who your real competitor is.",
    notes: "Post 2 still needs finishing — what makes a product durable?",
    drafts: 1,
  },
  {
    id: 2,
    title: "Certificate - Building a Product Roadmap",
    topic: "Roadmaps",
    status: "done",
    scheduledDate: "2026-02-23",
    hook: "A roadmap isn't about predicting the future. It's about aligning people around intent.",
    notes: "",
    drafts: 1,
  },
  {
    id: 3,
    title: "What is an AI Agent anyway?",
    topic: "AI & Product",
    status: "done",
    scheduledDate: "2026-02-23",
    hook: "A chatbot responds. An agent decides and acts.",
    notes: "Wed + Fri posts. Friday angle: designing boundaries is the hard part.",
    drafts: 2,
  },
  {
    id: 4,
    title: "User Interviews for Product",
    topic: "Customer Research",
    status: "done",
    scheduledDate: "2026-02-17",
    hook: "Customer knowledge is the superpower of a product manager.",
    notes: "Two posts: T & Th",
    drafts: 2,
  },
  {
    id: 5,
    title: "Stakeholders for Product",
    topic: "Stakeholders",
    status: "done",
    scheduledDate: "2026-02-13",
    hook: "The real goal of a product roadmap isn't the product. It's stakeholder alignment.",
    notes: "3 posts: T, W, F",
    drafts: 3,
  },
];

const IDEAS = [
  { id: 101, title: "When to kill a feature vs fix it", topic: "Product Strategy" },
  { id: 102, title: "What 'done' really means on a PM roadmap", topic: "Roadmaps" },
  { id: 103, title: "The PM's relationship with engineering", topic: "Team Dynamics" },
  { id: 104, title: "How I learned to love saying no", topic: "Prioritization" },
  { id: 105, title: "Metrics that lie vs metrics that lead", topic: "Data & Metrics" },
];

const TOPICS = ["All", "AI & Product", "Roadmaps", "Customer Research", "Stakeholders", "Product Strategy", "Team Dynamics", "Prioritization", "Data & Metrics"];
const STATUSES = ["idea", "drafting", "in-progress", "scheduled", "done"];

const STATUS_META = {
  idea: { label: "Idea", color: "#6B7280", bg: "rgba(107,114,128,0.12)" },
  drafting: { label: "Drafting", color: "#F59E0B", bg: "rgba(245,158,11,0.12)" },
  "in-progress": { label: "In Progress", color: "#3B82F6", bg: "rgba(59,130,246,0.12)" },
  scheduled: { label: "Scheduled", color: "#8B5CF6", bg: "rgba(139,92,246,0.12)" },
  done: { label: "Done", color: "#10B981", bg: "rgba(16,185,129,0.12)" },
};

const TOPIC_COLORS = {
  "AI & Product": "#F97316",
  Roadmaps: "#3B82F6",
  "Customer Research": "#EC4899",
  Stakeholders: "#8B5CF6",
  "Product Strategy": "#14B8A6",
  "Team Dynamics": "#F59E0B",
  Prioritization: "#EF4444",
  "Data & Metrics": "#10B981",
};

function StatusBadge({ status }) {
  const m = STATUS_META[status] || STATUS_META.idea;
  return (
    <span style={{
      fontSize: "11px", fontWeight: 600, letterSpacing: "0.05em",
      color: m.color, background: m.bg,
      padding: "3px 9px", borderRadius: "20px", textTransform: "uppercase",
      border: `1px solid ${m.color}30`,
    }}>{m.label}</span>
  );
}

function TopicTag({ topic }) {
  const color = TOPIC_COLORS[topic] || "#6B7280";
  return (
    <span style={{
      fontSize: "11px", color, background: `${color}15`,
      padding: "2px 8px", borderRadius: "4px", fontWeight: 500,
      border: `1px solid ${color}25`,
    }}>{topic}</span>
  );
}

function PostCard({ post, onEdit, onStatusChange }) {
  return (
    <div style={{
      background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)",
      borderRadius: "12px", padding: "18px 20px", cursor: "pointer",
      transition: "all 0.2s", position: "relative",
    }}
      onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,0.07)"; e.currentTarget.style.borderColor = "rgba(255,255,255,0.15)"; }}
      onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,0.04)"; e.currentTarget.style.borderColor = "rgba(255,255,255,0.08)"; }}
      onClick={() => onEdit(post)}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "10px", gap: "12px" }}>
        <div style={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
          <StatusBadge status={post.status} />
          <TopicTag topic={post.topic} />
        </div>
        {post.scheduledDate && (
          <span style={{ fontSize: "11px", color: "#6B7280", whiteSpace: "nowrap" }}>
            {new Date(post.scheduledDate + "T12:00:00").toLocaleDateString("en-US", { month: "short", day: "numeric" })}
          </span>
        )}
      </div>
      <div style={{ fontFamily: "'Playfair Display', serif", fontSize: "15px", fontWeight: 600, color: "#F1F0ED", marginBottom: "8px", lineHeight: 1.4 }}>
        {post.title}
      </div>
      {post.hook && (
        <div style={{ fontSize: "12px", color: "#9CA3AF", lineHeight: 1.5, fontStyle: "italic", borderLeft: "2px solid rgba(255,255,255,0.1)", paddingLeft: "10px", marginBottom: "10px" }}>
          "{post.hook}"
        </div>
      )}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontSize: "11px", color: "#6B7280" }}>
          {post.drafts} {post.drafts === 1 ? "draft" : "drafts"}
        </span>
        <select
          value={post.status}
          onClick={e => e.stopPropagation()}
          onChange={e => { e.stopPropagation(); onStatusChange(post.id, e.target.value); }}
          style={{
            fontSize: "11px", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)",
            color: "#9CA3AF", borderRadius: "6px", padding: "3px 6px", cursor: "pointer",
          }}
        >
          {STATUSES.map(s => <option key={s} value={s}>{STATUS_META[s].label}</option>)}
        </select>
      </div>
    </div>
  );
}

function EditModal({ post, onSave, onClose, onDelete }) {
  const [form, setForm] = useState({ ...post });
  const up = (k, v) => setForm(f => ({ ...f, [k]: v }));

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", zIndex: 100,
      display: "flex", alignItems: "center", justifyContent: "center", padding: "20px",
    }} onClick={onClose}>
      <div style={{
        background: "#151515", border: "1px solid rgba(255,255,255,0.12)",
        borderRadius: "16px", padding: "28px", width: "100%", maxWidth: "560px",
        maxHeight: "85vh", overflowY: "auto",
      }} onClick={e => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "22px" }}>
          <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "18px", color: "#F1F0ED", margin: 0 }}>
            {post.id ? "Edit Post" : "New Post"}
          </h2>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "#6B7280", cursor: "pointer", fontSize: "20px" }}>×</button>
        </div>

        {[
          ["Title", "title", "text"],
          ["Hook / Opening line", "hook", "text"],
          ["Scheduled Date", "scheduledDate", "date"],
        ].map(([label, key, type]) => (
          <div key={key} style={{ marginBottom: "16px" }}>
            <label style={{ fontSize: "11px", color: "#6B7280", textTransform: "uppercase", letterSpacing: "0.07em", display: "block", marginBottom: "6px" }}>{label}</label>
            <input type={type} value={form[key] || ""} onChange={e => up(key, e.target.value)}
              style={{ width: "100%", background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "8px", padding: "9px 12px", color: "#F1F0ED", fontSize: "14px", boxSizing: "border-box" }} />
          </div>
        ))}

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "16px" }}>
          <div>
            <label style={{ fontSize: "11px", color: "#6B7280", textTransform: "uppercase", letterSpacing: "0.07em", display: "block", marginBottom: "6px" }}>Topic</label>
            <select value={form.topic} onChange={e => up("topic", e.target.value)}
              style={{ width: "100%", background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "8px", padding: "9px 12px", color: "#F1F0ED", fontSize: "13px" }}>
              {TOPICS.filter(t => t !== "All").map(t => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>
          <div>
            <label style={{ fontSize: "11px", color: "#6B7280", textTransform: "uppercase", letterSpacing: "0.07em", display: "block", marginBottom: "6px" }}>Status</label>
            <select value={form.status} onChange={e => up("status", e.target.value)}
              style={{ width: "100%", background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "8px", padding: "9px 12px", color: "#F1F0ED", fontSize: "13px" }}>
              {STATUSES.map(s => <option key={s} value={s}>{STATUS_META[s].label}</option>)}
            </select>
          </div>
        </div>

        <div style={{ marginBottom: "16px" }}>
          <label style={{ fontSize: "11px", color: "#6B7280", textTransform: "uppercase", letterSpacing: "0.07em", display: "block", marginBottom: "6px" }}>Notes</label>
          <textarea value={form.notes || ""} onChange={e => up("notes", e.target.value)} rows={3}
            style={{ width: "100%", background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "8px", padding: "9px 12px", color: "#F1F0ED", fontSize: "13px", resize: "vertical", boxSizing: "border-box" }} />
        </div>

        <div style={{ marginBottom: "22px" }}>
          <label style={{ fontSize: "11px", color: "#6B7280", textTransform: "uppercase", letterSpacing: "0.07em", display: "block", marginBottom: "6px" }}>Number of Drafts</label>
          <input type="number" min="0" max="10" value={form.drafts || 0} onChange={e => up("drafts", parseInt(e.target.value) || 0)}
            style={{ width: "80px", background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: "8px", padding: "9px 12px", color: "#F1F0ED", fontSize: "14px" }} />
        </div>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {post.id && (
            <button onClick={() => onDelete(post.id)} style={{ background: "rgba(239,68,68,0.1)", border: "1px solid rgba(239,68,68,0.3)", color: "#EF4444", borderRadius: "8px", padding: "9px 16px", cursor: "pointer", fontSize: "13px" }}>
              Delete
            </button>
          )}
          <div style={{ display: "flex", gap: "10px", marginLeft: "auto" }}>
            <button onClick={onClose} style={{ background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)", color: "#9CA3AF", borderRadius: "8px", padding: "9px 18px", cursor: "pointer", fontSize: "13px" }}>
              Cancel
            </button>
            <button onClick={() => onSave(form)} style={{ background: "#F97316", border: "none", color: "white", borderRadius: "8px", padding: "9px 22px", cursor: "pointer", fontSize: "13px", fontWeight: 600 }}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function App() {
  const [posts, setPosts] = useState(initialPosts);
  const [ideas] = useState(IDEAS);
  const [filterTopic, setFilterTopic] = useState("All");
  const [filterStatus, setFilterStatus] = useState("All");
  const [editPost, setEditPost] = useState(null);
  const [isNew, setIsNew] = useState(false);
  const [view, setView] = useState("board"); // board | pipeline | ideas

  const filtered = posts.filter(p =>
    (filterTopic === "All" || p.topic === filterTopic) &&
    (filterStatus === "All" || p.status === filterStatus)
  );

  const stats = {
    total: posts.length,
    done: posts.filter(p => p.status === "done").length,
    inFlight: posts.filter(p => ["drafting", "in-progress", "scheduled"].includes(p.status)).length,
    ideas: posts.filter(p => p.status === "idea").length + ideas.length,
  };

  const handleSave = (form) => {
    if (isNew) {
      setPosts(ps => [...ps, { ...form, id: Date.now() }]);
    } else {
      setPosts(ps => ps.map(p => p.id === form.id ? form : p));
    }
    setEditPost(null);
    setIsNew(false);
  };

  const handleDelete = (id) => {
    setPosts(ps => ps.filter(p => p.id !== id));
    setEditPost(null);
  };

  const handleStatusChange = (id, status) => {
    setPosts(ps => ps.map(p => p.id === id ? { ...p, status } : p));
  };

  const newPost = () => {
    setIsNew(true);
    setEditPost({ id: null, title: "", topic: "AI & Product", status: "idea", scheduledDate: "", hook: "", notes: "", drafts: 0 });
  };

  const pipelineGroups = STATUSES.map(s => ({
    status: s,
    posts: posts.filter(p => p.status === s),
  }));

  return (
    <div style={{
      minHeight: "100vh", background: "#0D0D0D", color: "#F1F0ED",
      fontFamily: "'DM Sans', 'Helvetica Neue', sans-serif",
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=DM+Sans:wght@400;500;600&display=swap');
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { width: 6px; } ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 3px; }
        input, select, textarea { outline: none; color-scheme: dark; }
        input:focus, select:focus, textarea:focus { border-color: rgba(249,115,22,0.5) !important; }
      `}</style>

      {/* Header */}
      <div style={{ borderBottom: "1px solid rgba(255,255,255,0.07)", padding: "0 32px" }}>
        <div style={{ maxWidth: "1100px", margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between", height: "64px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div style={{ width: "28px", height: "28px", background: "#F97316", borderRadius: "6px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>✍</div>
            <div>
              <div style={{ fontFamily: "'Playfair Display', serif", fontSize: "15px", fontWeight: 700, letterSpacing: "-0.01em" }}>PM Content OS</div>
              <div style={{ fontSize: "10px", color: "#6B7280", letterSpacing: "0.05em" }}>LINKEDIN CONTENT PLANNER</div>
            </div>
          </div>
          <button onClick={newPost} style={{
            background: "#F97316", border: "none", color: "white", borderRadius: "8px",
            padding: "8px 18px", cursor: "pointer", fontSize: "13px", fontWeight: 600,
            display: "flex", alignItems: "center", gap: "6px",
          }}>+ New Post</button>
        </div>
      </div>

      <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "28px 32px" }}>

        {/* Stats */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "12px", marginBottom: "28px" }}>
          {[
            { label: "Total Posts", value: stats.total, color: "#F97316" },
            { label: "Published", value: stats.done, color: "#10B981" },
            { label: "In Flight", value: stats.inFlight, color: "#3B82F6" },
            { label: "Ideas", value: stats.ideas, color: "#8B5CF6" },
          ].map(s => (
            <div key={s.label} style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: "10px", padding: "16px 18px" }}>
              <div style={{ fontSize: "28px", fontWeight: 700, color: s.color, fontFamily: "'Playfair Display', serif", lineHeight: 1 }}>{s.value}</div>
              <div style={{ fontSize: "11px", color: "#6B7280", marginTop: "5px", textTransform: "uppercase", letterSpacing: "0.06em" }}>{s.label}</div>
            </div>
          ))}
        </div>

        {/* View Tabs + Filters */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", flexWrap: "wrap", gap: "12px" }}>
          <div style={{ display: "flex", gap: "4px", background: "rgba(255,255,255,0.04)", borderRadius: "8px", padding: "4px" }}>
            {[["board", "Grid"], ["pipeline", "Pipeline"], ["ideas", "Ideas Bank"]].map(([v, l]) => (
              <button key={v} onClick={() => setView(v)} style={{
                background: view === v ? "rgba(249,115,22,0.15)" : "transparent",
                border: view === v ? "1px solid rgba(249,115,22,0.3)" : "1px solid transparent",
                color: view === v ? "#F97316" : "#6B7280", borderRadius: "6px",
                padding: "6px 14px", cursor: "pointer", fontSize: "13px", fontWeight: 500,
              }}>{l}</button>
            ))}
          </div>
          {view !== "ideas" && (
            <div style={{ display: "flex", gap: "10px" }}>
              <select value={filterTopic} onChange={e => setFilterTopic(e.target.value)}
                style={{ background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", color: "#9CA3AF", borderRadius: "8px", padding: "7px 12px", fontSize: "12px" }}>
                {TOPICS.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
              <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)}
                style={{ background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", color: "#9CA3AF", borderRadius: "8px", padding: "7px 12px", fontSize: "12px" }}>
                <option value="All">All Statuses</option>
                {STATUSES.map(s => <option key={s} value={s}>{STATUS_META[s].label}</option>)}
              </select>
            </div>
          )}
        </div>

        {/* Board View */}
        {view === "board" && (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "14px" }}>
            {filtered.length === 0 && (
              <div style={{ gridColumn: "1/-1", textAlign: "center", color: "#4B5563", padding: "60px 0", fontSize: "14px" }}>
                No posts match your filters.
              </div>
            )}
            {filtered.map(p => (
              <PostCard key={p.id} post={p} onEdit={setEditPost} onStatusChange={handleStatusChange} />
            ))}
          </div>
        )}

        {/* Pipeline View */}
        {view === "pipeline" && (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: "12px", alignItems: "start" }}>
            {pipelineGroups.map(({ status, posts: colPosts }) => {
              const m = STATUS_META[status];
              return (
                <div key={status}>
                  <div style={{ display: "flex", alignItems: "center", gap: "7px", marginBottom: "12px" }}>
                    <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: m.color }} />
                    <span style={{ fontSize: "11px", fontWeight: 600, color: "#9CA3AF", textTransform: "uppercase", letterSpacing: "0.06em" }}>{m.label}</span>
                    <span style={{ fontSize: "11px", color: "#4B5563", marginLeft: "auto" }}>{colPosts.length}</span>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    {colPosts.map(p => (
                      <div key={p.id} onClick={() => setEditPost(p)} style={{
                        background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.07)",
                        borderRadius: "10px", padding: "14px", cursor: "pointer",
                        borderLeft: `3px solid ${m.color}`,
                      }}
                        onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.07)"}
                        onMouseLeave={e => e.currentTarget.style.background = "rgba(255,255,255,0.04)"}
                      >
                        <div style={{ fontSize: "13px", fontFamily: "'Playfair Display', serif", fontWeight: 600, color: "#F1F0ED", marginBottom: "6px", lineHeight: 1.35 }}>{p.title}</div>
                        <TopicTag topic={p.topic} />
                        {p.scheduledDate && (
                          <div style={{ fontSize: "10px", color: "#6B7280", marginTop: "7px" }}>
                            📅 {new Date(p.scheduledDate + "T12:00:00").toLocaleDateString("en-US", { month: "short", day: "numeric" })}
                          </div>
                        )}
                      </div>
                    ))}
                    {colPosts.length === 0 && (
                      <div style={{ border: "1px dashed rgba(255,255,255,0.07)", borderRadius: "10px", padding: "20px", textAlign: "center", color: "#374151", fontSize: "12px" }}>
                        Empty
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Ideas Bank */}
        {view === "ideas" && (
          <div>
            <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "16px" }}>
              Raw ideas waiting to become posts. Click any to promote to your board.
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: "12px" }}>
              {ideas.map(idea => (
                <div key={idea.id} style={{
                  background: "rgba(139,92,246,0.05)", border: "1px dashed rgba(139,92,246,0.2)",
                  borderRadius: "10px", padding: "16px 18px", cursor: "pointer",
                  transition: "all 0.2s",
                }}
                  onMouseEnter={e => { e.currentTarget.style.background = "rgba(139,92,246,0.1)"; e.currentTarget.style.borderColor = "rgba(139,92,246,0.4)"; }}
                  onMouseLeave={e => { e.currentTarget.style.background = "rgba(139,92,246,0.05)"; e.currentTarget.style.borderColor = "rgba(139,92,246,0.2)"; }}
                  onClick={() => {
                    setIsNew(true);
                    setEditPost({ id: null, title: idea.title, topic: idea.topic, status: "idea", scheduledDate: "", hook: "", notes: "", drafts: 0 });
                    setView("board");
                  }}
                >
                  <div style={{ fontSize: "14px", fontFamily: "'Playfair Display', serif", fontWeight: 600, color: "#F1F0ED", marginBottom: "8px" }}>{idea.title}</div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <TopicTag topic={idea.topic} />
                    <span style={{ fontSize: "11px", color: "#8B5CF6" }}>→ Promote</span>
                  </div>
                </div>
              ))}
            </div>

            <div style={{ marginTop: "32px", padding: "20px", background: "rgba(255,255,255,0.02)", border: "1px solid rgba(255,255,255,0.06)", borderRadius: "12px" }}>
              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "12px", textTransform: "uppercase", letterSpacing: "0.06em" }}>Your posting formula</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "10px" }}>
                {[["Hook", "A belief, mistake, or tension"], ["Context", "What situation you were in"], ["Insight", "What you chose or learned"], ["Why it matters", "For users, teams, or outcomes"]].map(([t, d], i) => (
                  <div key={t} style={{ background: "rgba(255,255,255,0.03)", borderRadius: "8px", padding: "12px" }}>
                    <div style={{ fontSize: "10px", color: "#F97316", fontWeight: 700, marginBottom: "4px" }}>{i + 1}. {t}</div>
                    <div style={{ fontSize: "11px", color: "#6B7280" }}>{d}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Edit Modal */}
      {editPost && (
        <EditModal
          post={editPost}
          onSave={handleSave}
          onClose={() => { setEditPost(null); setIsNew(false); }}
          onDelete={handleDelete}
        />
      )}
    </div>
  );
}
